import Requirement from 'components/framework/models/Requirement';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class RequirementFields extends RecordFields {
  static modelClass = Requirement;
}

registerRecordFieldsClasses({ RequirementFields });
